import { marshal, Nullable } from "@gsx/common";
import { injectable } from "inversify";
import { EditStore } from "../../general/EditStore";
import { Api } from "../../../../../common/src/api/Api";
import { FlashNewsBody } from "@gsx/common/src/types/http/admin/flashNews";
import { createFlashNewsEmptyBody } from "../../../../src/utility/entity/flashNews";

// EditStoreVuex is not used here, because components are modifying
// data properties directly. That behaviour is not supported by vuex.
// The whole data would have to be replaced instead.

@injectable()
export class FlashNewsEditStore extends EditStore<FlashNewsBody> {
    private id: string = "";
    readonly data: Nullable<FlashNewsBody> = createFlashNewsEmptyBody();
    flashNewsMedia: FormData = new FormData();

    constructor(private readonly api: Api) {
        super();
    }

    public setId(value: string): void {
        this.id = value;
    }

    protected async loadRequest(): Promise<FlashNewsBody> {
        return this.api.admin.flashNews.get(this.id);
    }

    protected async updateRequest(): Promise<void> {
        const body = marshal(this.data);
        await this.api.admin.flashNews.update(this.id, body, this.flashNewsMedia);
    }
}
